/* Panier Hydraleaf : minuteur, code de réduction et rafraîchissement des sections. */
(function () {
  const TIMER_KEY = 'hlCartTimerEnd';
  let memoryEnd = 0;

  function readEnd() {
    try {
      return Number(localStorage.getItem(TIMER_KEY)) || 0;
    } catch (e) {
      return memoryEnd;
    }
  }

  function writeEnd(value) {
    memoryEnd = value;
    try {
      if (value) localStorage.setItem(TIMER_KEY, String(value));
      else localStorage.removeItem(TIMER_KEY);
    } catch (e) {}
  }

  // « Votre panier expire dans 04:55 ». Le tiroir est re-rendu à chaque changement de panier :
  // l'échéance vit dans localStorage pour que le décompte continue d'un rendu à l'autre.
  // À zéro, on relance le décompte (le panier n'est jamais vidé).
  class HlCartTimer extends HTMLElement {
    connectedCallback() {
      this.duration = (Number(this.dataset.minutes) || 5) * 60000;
      this.output = this.querySelector('[data-time]');
      clearInterval(this.interval);
      if (this.dataset.empty === 'true') {
        writeEnd(0);
        this.render(this.duration);
        return;
      }
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      let end = readEnd();
      if (!end || end <= Date.now()) {
        end = Date.now() + this.duration;
        writeEnd(end);
      }
      this.render(end - Date.now());
    }

    render(ms) {
      if (!this.output) return;
      const seconds = Math.max(0, Math.ceil(ms / 1000));
      const text = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
      if (this.output.textContent !== text) this.output.textContent = text;
    }
  }

  if (!customElements.get('hl-cart-timer')) customElements.define('hl-cart-timer', HlCartTimer);

  // Tiroir façon rejenbeauty.com : « Votre panier est réservé pendant 09:41 minutes ».
  // Le décompte part au premier article du panier (clé = jeton du panier), survit aux rechargements,
  // s'arrête à zéro sur un message, et repart de zéro quand le panier est vidé.
  const RESERVE_KEY = 'hlCartReserve';
  let memoryReserve = null;

  function readReserve() {
    try {
      return JSON.parse(localStorage.getItem(RESERVE_KEY) || 'null');
    } catch (e) {
      return memoryReserve;
    }
  }

  function writeReserve(value) {
    memoryReserve = value;
    try {
      if (value) localStorage.setItem(RESERVE_KEY, JSON.stringify(value));
      else localStorage.removeItem(RESERVE_KEY);
    } catch (e) {}
  }

  class HlReserveTimer extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);
      if (this.dataset.empty === 'true') {
        writeReserve(null);
        return;
      }
      const token = this.dataset.token || '';
      let saved = readReserve();
      if (!saved || saved.t !== token) {
        saved = { t: token, s: Date.now() };
        writeReserve(saved);
      }
      this.start = saved.s;
      this.duration = (Number(this.dataset.minutes) || 10) * 60000;
      this.output = this.querySelector('[data-time]');
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const left = this.duration - (Date.now() - this.start);
      if (left <= 0) {
        clearInterval(this.interval);
        this.classList.add('is-expired');
        this.textContent = 'Temps écoulé ! Vous pouvez quand même finaliser votre commande';
        return;
      }
      const seconds = Math.ceil(left / 1000);
      const text = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
      if (this.output && this.output.textContent !== text) this.output.textContent = text;
    }
  }

  if (!customElements.get('hl-reserve-timer')) customElements.define('hl-reserve-timer', HlReserveTimer);

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  // Re-rend le tiroir, la pastille du panier et la page /cart après un changement de code promo.
  async function refreshCart() {
    const drawer = document.querySelector('cart-drawer');
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    const ids = ['cart-icon-bubble'];
    if (drawer) ids.push('cart-drawer');
    if (items) ids.push(items.dataset.id);
    if (footer) ids.push(footer.dataset.id);

    const sections = await fetch(`${window.location.pathname}?sections=${ids.join(',')}`).then((r) => r.json());

    if (drawer && sections['cart-drawer']) {
      const inner = drawer.querySelector('.drawer__inner');
      const fresh = parse(sections['cart-drawer']).querySelector('.drawer__inner');
      const wasOpen = !!inner.querySelector('.hl-cd__discount[open]');
      if (fresh) inner.innerHTML = fresh.innerHTML;
      if (wasOpen) inner.querySelector('.hl-cd__discount')?.setAttribute('open', '');
    }
    if (items && sections[items.dataset.id]) {
      const fresh = parse(sections[items.dataset.id]).querySelector('#main-cart-items .js-contents');
      if (fresh) items.querySelector('.js-contents').innerHTML = fresh.innerHTML;
    }
    if (footer && sections[footer.dataset.id]) {
      const fresh = parse(sections[footer.dataset.id]).querySelector('#main-cart-footer .js-contents');
      if (fresh) footer.querySelector('.js-contents').innerHTML = fresh.innerHTML;
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const fresh = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (fresh) bubble.innerHTML = fresh.innerHTML;
    }
  }

  async function setCodes(codes) {
    const response = await fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    });
    return response.json();
  }

  async function currentCodes() {
    const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
    return (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
  }

  class HlCartDiscount extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.input = this.querySelector('.hl-discount__input');
      this.error = this.querySelector('.hl-discount__error');
      this.querySelector('.hl-discount__btn')?.addEventListener('click', () => this.apply());
      this.input?.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.apply();
        }
      });
      this.querySelectorAll('.hl-discount__remove').forEach((button) =>
        button.addEventListener('click', () => this.remove(button.dataset.code))
      );
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = !message;
    }

    async apply() {
      const code = (this.input?.value || '').trim();
      if (!code) return this.showError('Veuillez saisir un code');
      this.showError('');
      this.classList.add('is-loading');
      try {
        const existing = await currentCodes();
        if (existing.some((c) => c.toLowerCase() === code.toLowerCase())) {
          return this.showError('Ce code promo est déjà appliqué');
        }
        const cart = await setCodes([...existing, code]);
        const hit = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
        if (!hit || !hit.applicable) {
          await setCodes(existing);
          return this.showError("Ce code promo n'est pas applicable");
        }
        await refreshCart();
      } catch (e) {
        this.showError("Erreur lors de l'application du code de réduction");
      } finally {
        this.classList.remove('is-loading');
      }
    }

    async remove(code) {
      this.classList.add('is-loading');
      try {
        const existing = await currentCodes();
        await setCodes(existing.filter((c) => c.toLowerCase() !== String(code).toLowerCase()));
        await refreshCart();
      } catch (e) {
        this.showError('Erreur lors de la suppression du code de réduction');
      } finally {
        this.classList.remove('is-loading');
      }
    }
  }

  if (!customElements.get('hl-cart-discount')) customElements.define('hl-cart-discount', HlCartDiscount);
})();
